import React, { useContext, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import NotesColumn from 'chameleon/packages/blue-book-player/library/NotesColumn';
import useGetPlayerEl from 'chameleon/packages/blue-book-player/hooks/useGetPlayerEl';
import { getItemByRef } from 'chameleon/packages/blue-book-player/utils';
import { BluebookAnnotationsContext } from 'chameleon/packages/blue-book-player/state/BluebookAnnotationsContext';
import { getCurrentAnnotations } from 'chameleon/packages/blue-book-player/library/HighlightsNotesWrapper/utils';

const isReferenceInArray = (array, reference) =>
  array.some((item) => item.questionReference === reference);

const NotesColumnInjector = (props) => {
  const [injectNotesColumn, setInjectNotesColumn] = useState(false);
  const [questionNotesDetails, setQuestionNotesDetails] = useState([]);
  const [itemRefAnnotations, setItemRefAnnotations] = useState([]);
  const playerEl = useGetPlayerEl();
  const { learnosityItemReference, playerState, isQuestionDisplayed } = props;
  const { state: { annotations = [] } = {} } =
    useContext(BluebookAnnotationsContext) || {};

  useEffect(() => {
    if (learnosityItemReference && isQuestionDisplayed) {
      const currentAnnotations = getCurrentAnnotations(
        annotations,
        learnosityItemReference,
      );
      setItemRefAnnotations(currentAnnotations);
    }
  }, [annotations, learnosityItemReference, isQuestionDisplayed]);

  useEffect(() => {
    if (
      playerEl &&
      learnosityItemReference &&
      !isReferenceInArray(questionNotesDetails, learnosityItemReference) &&
      isQuestionDisplayed
    ) {
      const element = getItemByRef(playerEl, learnosityItemReference);
      if (playerState.isLearnosityApiReady && element) {
        const isOneColumn = element.classList.contains('one-column');
        const targetElement = isOneColumn
          ? element
          : element.querySelector('.left-column');

        if (targetElement) {
          setQuestionNotesDetails((prev) => [
            ...prev,
            {
              parentElement: targetElement,
              isInLeftColumn: !isOneColumn,
              questionReference: learnosityItemReference,
            },
          ]);
        }
      }
    }

    setInjectNotesColumn(itemRefAnnotations.length !== 0);
  }, [
    playerEl,
    itemRefAnnotations,
    playerState.isLearnosityApiReady,
    isQuestionDisplayed,
    learnosityItemReference,
  ]);

  return (
    !isEmpty(itemRefAnnotations) &&
    isQuestionDisplayed &&
    injectNotesColumn &&
    questionNotesDetails.map((questionNotesDetail) =>
      createPortal(
        <NotesColumn
          key={questionNotesDetail.questionReference}
          parentElement={questionNotesDetail.parentElement}
          isInLeftColumn={questionNotesDetail.isInLeftColumn}
          learnosityItemReference={learnosityItemReference}
          itemRefAnnotations={itemRefAnnotations}
        />,
        questionNotesDetail.parentElement,
      ),
    )
  );
};

NotesColumnInjector.propTypes = {
  learnosityItemReference: PropTypes.string,
  itemRefAnnotations: PropTypes.arrayOf(PropTypes.object),
};

NotesColumnInjector.defaultProps = {
  learnosityItemReference: null,
  itemRefAnnotations: [],
};

export default NotesColumnInjector;
